<template>
    <div class="item">
        <div class="item_content" v-show="$route.name == 'item'">
            <title-bar :title="projectName" type="back" :back-cb="backTo">
                <div slot="right" class="proto" @touchstart="toProto">预览原型</div>
                <div slot="more" class="title_bar_more">
                    <div class="sector" @click="showSector">{{ sector.name }}</div>
                    <div class="btn_wrapper">
                        <span class="sort_btn" @click="toggleSortDialog"></span>
                        <span class="search_btn" @click="toSearch"></span>
                    </div>
                </div>
            </title-bar>
            <sort-type-dialog
                :textArr="sortTypeArr"
                :text="sortType"
                :showSortDialog.sync="showSortDialog"
                @changeSortType="changeSortType"
            ></sort-type-dialog>

            <mescroll-vue
                ref="mescroll"
                :down="mescrollDown"
                :up="mescrollUp"
                @init="mescrollInit"
                :class="{ android: android }"
            >
                <div class="item_desgins">
                    <ul v-for="(item, index) in list" :key="index" class="content">
                        <li
                            :class="'item-' + index2"
                            v-for="(item2, index2) in item"
                            :key="index2"
                            :style="{ height: item2._height + 'px' }"
                        >
                            <router-link :to="item2.link">
                                <img :imgurl="item2.src" src="@/assets/imgs/holder.png" />
                                <div class="img_info">
                                    <div class="img_info_center">
                                        <p class="desgin_name">{{ item2.name }}</p>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </mescroll-vue>

            <div class="sector_wrap" v-show="sector.show">
                <sector
                    :project-id="projectId"
                    :selected-id="sector.id"
                    @close="closeSector"
                    @select="selectSector"
                ></sector>
            </div>
            <div class="tip" v-show="showTip">
                <img class="no-design" src="../../assets/imgs/no-design.png" alt="没有设计图" />
                <div>没有内容</div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import API from "../../api/api.js"
import titleBar from "@/components/layout/TitleBar"
import sector from "./Sector"
// import 'mescroll.js/mescroll.min.css'
import MescrollVue from "mescroll.js/mescroll.vue"
import SortTypeDialog from "./SortTypeDialog.vue"
// import "../../assets/js/natural-sort/natural-sort.js"
import naturalSort from "natural-sort"
import pinyin from "pinyin"

export default {
    components: {
        titleBar,
        sector,
        MescrollVue,
        SortTypeDialog
    },
    
    data() {
        return {
            sortType: "最近更新",
            list_sort: [],
            showSortDialog: false,
            sortTypeArr: [
                {
                    id: 0,
                    text: "最近更新"
                },
                {
                    id: 1,
                    text: "按名称A-Z"
                }
            ],
            list: [],
            showTip: false,
            sector: {
                show: false,
                id: "all",
                name: "全部分组",
                images: []
            },
            projectName: "",
            homeImageId: "",
            mescroll: null, //下拉刷新
            mescrollDown: {
                auto: false,
                mustToTop: true,
                callback: this.pulldown,
                textInOffset: "",
                textOutOffset: "",
                textLoading: ""
            },
            mescrollUp: {
                lazyLoad: {
                    use: true,
                    attr: "imgurl",
                    showClass: "mescroll-lazy-in",
                    delay: 500,
                    offset: 200
                }
            }
        }
    },
    async mounted() {
        this.$root.eventBus.$emit("showLoading")
        /**
         * 排序方式：
         * 1.优先从缓存里读取
         * 2.缓存没有从后端接口读取
         * 3.都没有的话用默认值
         */
        let email = localStorage.email
        let sort_type = localStorage[`${email}_sort_type`]
        if (email && sort_type && sort_type !== "undefined") {
            // 缓存读取
            this.sortType = localStorage[`${email}_sort_type`]
        } else {
            let result = await this.getSortType()
            if (result) {
                // 后端接口读取
                this.sortType = result
            } else {
                // 默认值
                this.sortType = "最近更新"
            }
        }
        this.changeSortType(this.sortType)
    },
    computed: {
        android() {
            return window.system === "android"
        },
        projectId() {
            return this.$route.query.project_id
        }
    },
    methods: {
        /**
         *  从后端获取sort类型,没有的话就用默认值
         */
        async getSortType() {
            try {
                let url = `account/user_settings?settings_type=web_mobile`
                let response = await axios.get(url)
                let res = response.data
                if (response.status === 200) {
                    let result = response.data.result
                    if (result) {
                        result = JSON.parse(response.data.result)
                        return result.sort_type
                    } else {
                        return null
                    }
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * 对英文、数字、汉字、特殊字符组成的数组做自然排序
         */
        natualSortArr(arr) {
            // 第一步，得到把数组划分为3部分。 数字、英文 | 汉字 | 其他
            let num_en_arr = []
            let hanzi_arr = []
            let other_arr = []

            arr.forEach(item => {
                if (/^[\u4e00-\u9fa5]{1}/.test(item)) {
                    // 过滤出开头为汉字的
                    hanzi_arr.push(item)
                } else if (/^\d{1}/.test(item) || /^[a-zA-Z]{1}/.test(item)) {
                    // 过滤出开头为数字或者字母的
                    num_en_arr.push(item)
                } else {
                    // 过滤出开头为其他字符的
                    other_arr.push(item)
                }
            })

            // 第二步，把由汉字组成的数组，转化为由拼字组成的数组 和 拼音-汉字的映射对象
            let pinyinMap = {}
            let pinyin_arr = hanzi_arr.map(item => {
                let pinyinText = ""
                let pinyinArr = pinyin(item, {
                    style: pinyin.STYLE_NORMAL, // 设置拼音风格
                    heteronym: true
                })
                pinyinArr.forEach(str => {
                    pinyinText += str[0]
                })
                pinyinMap[pinyinText] = item
                return pinyinText
            })

            // 第三步，对拼音数组使用natural-sort排序，排完后再拼音转汉字
            let pinyin_arr_sort = pinyin_arr.sort(naturalSort())
            let hanzi_arr_sort = pinyin_arr_sort.map(item => {
                return pinyinMap[item]
            })

            // 第四步，对三个数组都做好排序，再拼接成一个数组
            let num_en_arr_sort = num_en_arr.sort(naturalSort())
            let other_arr_sort = other_arr.sort(naturalSort())

            let result = [...num_en_arr_sort, ...hanzi_arr_sort, ...other_arr_sort]
            // console.log("result", result)
            return result
        },

        toggleSortDialog() {
            this.showSortDialog = !this.showSortDialog
        },

        /**
         * 排序方式变化时触发
         */
        async changeSortType(type) {
            console.log("触发changeSortType", type)
            this.sortType = type

            // 缓存下来，这个排序方式，跟着该user账号走。
            let email = localStorage.email
            localStorage[`${email}_sort_type`] = type
            // 后端记录下来，排序方式，在没有缓存时使用接口数据
            try {
                let url = `account/user_settings`
                let data = {
                    sort_type: type
                }
                let params = {
                    web_mobile: JSON.stringify(data)
                }
                await axios.put(url, params)
            } catch (err) {
                console.log(err)
            }

            switch (type) {
                case "最近更新":
                    this.getImages()
                    break
                case "按名称A-Z":
                    this.getSortImages()
                    break
            }
        },

        mescrollInit(mescroll) {
            this.mescroll = mescroll
        },
        pulldown() {
            switch (this.sortType) {
                case "最近更新":
                    this.getImages("pull")
                    break
                case "按名称A-Z":
                    this.getSortImages("pull")
                    break
            }
        },

        async getImages(param) {
            let params = {
                pid: this.projectId
            }
            let res = await lanhuAPI.project.getProjectInfoOrigin(this.projectId)

            this.$root.eventBus.$emit("hideLoading")
            if (res) {
                let data = res
                
                // 给图片width/height
                // this.parseImageData(data.images)

                this.projectName = data.name
                localStorage.projectName = this.projectName

                let arr = []

                data.images.forEach(ele => {
                    if (ele.type != "card") {
                        arr.push({
                            id: ele.id,
                            name: ele.name,
                            src: ele.url,
                            height: ele.height,
                            width: ele.width,
                            link: {
                                name: "design",
                                query: {
                                    project_id: this.projectId,
                                    project_name: this.projectName,
                                    image_id: ele.id
                                }
                            }
                        })
                    }

                    if (ele.home) {
                        this.homeImageId = ele.id
                    }
                })

                window.imagesList = JSON.parse(JSON.stringify(arr))

                imagesList.forEach(ele => {
                    ele.src = window.mtd.handleImg(ele.src, {
                        ali: this.$root.isSupportWebp ? "?x-oss-process=image/format,webp" : "",
                        qiniu: ""
                    })
                })
                console.log(arr)
                this.list = this.toWaterfall(arr)

                if (!this.list[0].length && !this.list[1].length) {
                    this.showTip = true
                }

                if (this.mescroll) {
                    if (param == "pull") {
                        this.$root.eventBus.$emit("showTip", "更新成功", "normal")
                        this.selectSector(this.sector)
                        setTimeout(() => {
                            this.mescroll.endSuccess()
                        }, 1000)
                    } else {
                        this.mescroll.endSuccess()
                    }
                }
            }
        },

        async getSortImages(param) {
            let params = {
                pid: this.projectId,
                team_id: localStorage.teamId
            }
            let res = await lanhuAPI.project.getProjectInfoOrigin(this.projectId)
            this.$root.eventBus.$emit("hideLoading")
            if (res) {
                let data = res

                this.projectName = data.name
                localStorage.projectName = this.projectName

                let arr = []
                data.images.forEach(ele => {
                    if (ele.type != "card") {
                        arr.push({
                            id: ele.id,
                            name: ele.name,
                            src: ele.url,
                            height: ele.height,
                            width: ele.width,
                            link: {
                                name: "design",
                                query: {
                                    project_id: this.projectId,
                                    project_name: this.projectName,
                                    image_id: ele.id
                                }
                            }
                        })
                    }

                    if (ele.home) {
                        this.homeImageId = ele.id
                    }
                })

                window.imagesList = JSON.parse(JSON.stringify(arr))

                imagesList.forEach(ele => {
                    ele.src = window.mtd.handleImg(ele.src, {
                        ali: this.$root.isSupportWebp ? "?x-oss-process=image/format,webp" : "",
                        qiniu: ""
                    })
                })

                /**
                 * start
                 *
                 * 得到由name构成的数组，再得到name对应的item的一个key-value映射对象
                 * 利用naturalSort和pinyin库去排序,在把nameArr转化为由对象组成的arr
                 */

                let nameArr = arr.map(item => `${item.name}***${item.id}`)
                let nameMap = {}
                arr.forEach(item => {
                    let key = `${item.name}***${item.id}`
                    nameMap[key] = item
                })
                nameArr = this.natualSortArr(nameArr)
                let sortArr = nameArr.map(name => {
                    return nameMap[name]
                })
                this.list = this.toWaterfall(sortArr) // 排序后的data
                // 再切换排序方式后，Design.vue组件里的顺序也需要变化。所以按照之前的逻辑，需通过window传递的数据
                window.imagesList = JSON.parse(JSON.stringify(sortArr))
                /**
                 * end
                 */

                if (!this.list[0].length && !this.list[1].length) {
                    this.showTip = true
                }

                if (this.mescroll) {
                    if (param == "pull") {
                        this.$root.eventBus.$emit("showTip", "更新成功", "normal")
                        this.selectSector(this.sector)
                        setTimeout(() => {
                            this.mescroll.endSuccess()
                        }, 1000)
                    } else {
                        this.mescroll.endSuccess()
                    }
                }
            }
        },
        toWaterfall(listData) {
            let data = JSON.parse(JSON.stringify(listData))

            let json1 = { num: 0, arr: [] },
                json2 = { num: 0, arr: [] }

            let width = (document.querySelector(".item").offsetWidth - 30) / 2
            data.forEach(ele => {
                if (ele.src) {
                    let height = (Number(width) / Number(ele.width)) * Number(ele.height)
                    ele._height = height + 3 * parseInt(window.rem)
                    ele._width = width

                    let num = 2

                    ele.src = window.mtd.handleImg(ele.src, {
                        ali: this.$root.isSupportWebp
                            ? `?x-oss-process=image/resize,m_lfit,h_${Math.ceil(ele._height) * num},w_${Math.ceil(
                                  ele._width
                              ) * num}/format,webp`
                            : `?x-oss-process=image/resize,m_lfit,h_${Math.ceil(ele._height) * num},w_${Math.ceil(
                                  ele._width
                              ) * num}`,
                        qiniu: `?imageMogr2/w/${Math.ceil(ele._width) * num}/h/${Math.ceil(ele._height) * num}`
                    })

                    if (json1.num > json2.num) {
                        json2.arr.push(ele)
                        json2.num += ele._height + 10 //10是图片之间的margin-top
                    } else {
                        json1.arr.push(ele)
                        json1.num += ele._height + 10
                    }
                }
            })

            return [json1.arr, json2.arr]
        },
        toSector() {
            this.$router.push({
                name: "sector",
                query: {
                    id: this.sector.id,
                    project_id: this.projectId
                }
            })
        },
        toSearch() {
            this.$router.push({
                name: "search",
                query: {
                    project_id: this.projectId,
                    project_name: this.projectName
                }
            })

            MtaH5.clickStat("search_design")
        },
        toProto() {
            this.$router.push({
                name: "proto",
                query: {
                    project_id: this.projectId,
                    project_name: this.projectName,
                    image_id: this.homeImageId ? this.homeImageId : imagesList[0].id
                }
            })

            MtaH5.clickStat("preview_proto")
        },
        selectSector(item) {
            if (item.id == "all") {
                this.sector.id = "all"
                this.sector.name = "全部分组"
                this.sector.images = []
                this.list = this.toWaterfall(window.imagesList)
                this.mescroll.lazyLoad(100)
                // this.getImages();
            } else {
                this.sector.id = item.id
                this.sector.name = item.name
                this.sector.images = item.images

                if (item.images.length) {
                    let sectorList = []
                    this.sector.images.forEach(ele => {
                        imagesList.forEach(ele2 => {
                            if (ele == ele2.id) {
                                sectorList.push({
                                    id: ele2.id,
                                    name: ele2.name,
                                    src: ele2.src,
                                    height: ele2.height,
                                    width: ele2.width,
                                    link: {
                                        name: "design",
                                        query: {
                                            project_id: this.projectId,
                                            project_name: this.projectName,
                                            image_id: ele2.id
                                        }
                                    }
                                })
                            }
                        })
                    })

                    this.list = this.toWaterfall(sectorList)
                    this.mescroll.lazyLoad(100) //更新懒加载数据
                } else {
                    this.list = []
                }
            }

            let designsBox = this.$refs.mescroll.$el
            designsBox.scrollTop = 0
        },
        showSector() {
            this.sector.show = true
        },
        closeSector() {
            this.sector.show = false
        },
        backTo() {
            let team_id = localStorage.teamId
            this.$router.push({
                name: "team",
                query: {
                    team_id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.mescroll {
    &.android {
        top: 5.05rem !important;
    }
    position: fixed;
    // top: 3.5rem; //android_top
    top: 4.95rem; //ios_top
    top: calc(constant(safe-area-inset-top) + 3.95rem);
    top: calc(env(safe-area-inset-top) + 3.95rem);
    bottom: 0;
    height: auto;
}
.item {
    height: 100%;
    .item_content {
        width: 100%;
        height: 100%;
        text-align: center;
        position: relative;
        padding-top: 3.95rem;
        box-sizing: border-box;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
    }
    .tip {
        font-size: 0.7rem;
        color: rgba(136, 136, 136, 1);
        text-align: center;
        position: absolute;
        left: 0;
        top: 30%;
        width: 100%;
        .no-design {
            width: 13.25rem;
            margin-bottom: 1rem;
        }
    }
    .proto {
        a {
            color: #000000;
        }
    }
    .title_bar_more {
        height: 1.3rem;
        padding: 0 0.7rem 0.3rem 0.7rem;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .sector {
            font-size: 0.7rem;
        }
        .btn_wrapper {
            .sort_btn {
                display: inline-block;
                width: 1.3rem;
                height: 1.3rem;
                background: url("~@/assets/imgs/sort_icon.png") left top / 100% no-repeat;
                margin-right: 0.38rem;
            }
            .search_btn {
                display: inline-block;
                width: 1.3rem;
                height: 1.3rem;
                background: url("~@/assets/imgs/search_icon.png") left top / 100% no-repeat;
            }
        }
    }
    .loading {
        position: absolute;
        width: 2rem;
        height: 2rem;
        margin-top: 1rem;
        margin-left: -1rem;
    }
    .item_desgins {
        height: 100%;
        padding: 0 10px 20px 10px;
        overflow-y: auto;
        margin: 0 auto;
        box-sizing: border-box;
        background: #edeff1;
        ul {
            width: calc(50% - 5px);
            &:nth-child(1) {
                float: left;
            }
            &:nth-child(2) {
                float: right;
            }
            li {
                box-sizing: border-box;
                background: white;
                width: 100%;
                margin-top: 10px;
                box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                overflow: hidden;
                display: flex;
                align-items: center;
                padding-bottom: 3rem;
                position: relative;
                display: table;
                a {
                    display: table-cell;
                    vertical-align: middle;
                }
                img {
                    display: block;
                    width: 100%;
                }
            }
        }
        .img_info {
            background: white;
            height: 3rem;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            display: table;
            .img_info_center {
                display: table-cell;
                vertical-align: middle;
            }
        }
        .desgin_name {
            width: 100%;
            font-size: 0.7rem;
            color: #222222;
            text-align: center;
            padding: 0 0.5rem;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            box-sizing: border-box;
            max-height: 3rem;
            word-break: break-all;
        }
    }

    .sector_wrap {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 1rem;
        top: constant(safe-area-inset-top);
        top: env(safe-area-inset-top);
        z-index: 1111;
    }
}
</style>